import { DEBUG } from '@glimmer/env';
import { singularize } from 'ember-inflector';
import { normalizeModelName } from '@ember-data/store/-private';
/**
  @module @ember-data/store
*/

function typeForRelationshipMeta(meta) {
  let modelName = normalizeModelName(meta.type || meta.key);
  if (meta.kind === 'hasMany') {
    modelName = singularize(modelName);
  }
  return modelName;
}
function shouldFindInverse(relationshipMeta) {
  let options = relationshipMeta.options;
  return !(options && options.inverse === null);
}
export class RelationshipDefinition {
  constructor(meta) {
    this._type = '';
    this.__inverseKey = '';
    this.__inverseIsAsync = true;
    this.__hasCalculatedInverse = false;
    this.parentModelName = meta.parentModelName;
    this.meta = meta;
  }

  /**
   * @internal
   * @deprecated
   */
  get key() {
    return this.meta.key;
  }
  get kind() {
    return this.meta.kind;
  }
  get type() {
    if (this._type) {
      return this._type;
    }
    this._type = typeForRelationshipMeta(this.meta);
    return this._type;
  }
  get options() {
    return this.meta.options;
  }
  get name() {
    return this.meta.name;
  }
  _inverseKey(store, modelClass) {
    if (this.__hasCalculatedInverse === false) {
      this._calculateInverse(store, modelClass);
    }
    return this.__inverseKey;
  }
  _inverseIsAsync(store, modelClass) {
    if (this.__hasCalculatedInverse === false) {
      this._calculateInverse(store, modelClass);
    }
    return this.__inverseIsAsync;
  }
  _calculateInverse(store, modelClass) {
    this.__hasCalculatedInverse = true;
    let inverseKey, inverseIsAsync;
    let inverse = null;
    if (shouldFindInverse(this.meta)) {
      inverse = modelClass.inverseFor(this.key, store);
    } else if (DEBUG) {
      modelClass.typeForRelationship(this.key, store);
    }
    if (inverse) {
      inverseKey = inverse.name;
      inverseIsAsync = isRelationshipAsync(inverse);
    } else {
      inverseKey = null;
      inverseIsAsync = false;
    }
    this.__inverseKey = inverseKey;
    this.__inverseIsAsync = inverseIsAsync;
  }
}
function isRelationshipAsync(meta) {
  let inverseAsync = meta.options && meta.options.async;
  return typeof inverseAsync === 'undefined' ? true : inverseAsync;
}
export function relationshipFromMeta(meta) {
  return new RelationshipDefinition(meta);
}